'use strict';

var BaseGroup = require('config/Group');
var i18n = require('i18next');
var RenderPositions = require('config/RenderPositions');

/**
 * "Static Routes" configuration group.
 */
module.exports = BaseGroup.extend({
  actionList: [
    {
      name: 'staticRoutes',
      position: RenderPositions.full,
      required: true,
      renderTitle: false,
      renderStatic: true,
      doubleWide: false,
    },
  ],

  isConnectivityDisrupted: function(type, target) {
    return true;
  },

  /**
   * @return {Boolean}
   */
  isRequired: function() {
    return true;
  },

  /**
   * @return {String}
   */
  title: function() {
    return i18n.t('groups.staticRoutes');
  },

  shouldMergeTasks: false,
});
